//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MediaTrackingQueue } from '@tracker/mediaTracking/mediaTrackingEventQueue';
import { isProdBuild } from '@utils/envUtils';
import uuid from '@utils/uuid';

import { crl8 } from 'app/curalate.globals';

void crl8.userSessionPromise.then((session) => {
  // Session id is a unique id we assign to all events so they can be connected to a specific session
  const sessionId = uuid();

  // Set this to true if running locally and need to test media tracking for dev purposes
  const isTrackingEnabled =
    isProdBuild(CURALATE_ENV.RELEASE, location.hostname, navigator.webdriver) &&
    !session?.internalInfo.isCuralateEmployee;

  crl8.isMediaTrackingEnabled = isTrackingEnabled; // This is used by the MediaTracking React Context

  MediaTrackingQueue.init({
    sessionId,
    isTrackingEnabled,
    debugConfig: {
      isLoggingEnabled: false, // Set to true to log debugging information to console
      areMockApiCallsEnabled: false, // Set to true to mock api calls and not send to s3
    },
  });
});
